export default {
    getMaxMinDateString: function (date, days) {
        let myDate = new Date();
        myDate.setDate(date.getDate() + days);
        return myDate.toISOString().slice(0, 10);
    },
}